import React, { useMemo } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";

const WelcomeView = ({ height, assistant, language, handleExample }) => {
  // Function to get a sample of language questions
  const getLanguageQuestions = useMemo(() => {
    if (!assistant.language_questions || !language) {
      return assistant.quick_questions || [];
    }

    const languageQuestions = assistant.language_questions[language] || assistant.language_questions['en'];
    
    // If no questions available, return empty array
    if (!languageQuestions || languageQuestions.length < 3) {
      return assistant.quick_questions || [];
    }

    // Always include the second question
    const selectedQuestions = [languageQuestions[1]];
    
    // Get questions excluding first and last
    const availableQuestions = languageQuestions.slice(2, -1);
    
    // Select 3 random questions from the available ones
    const shuffled = [...availableQuestions].sort(() => 0.5 - Math.random());
    const randomSelected = shuffled.slice(0, 4);
    
    // Return 4 questions total (1 second question + 3 random)
    return [...selectedQuestions, ...randomSelected];
  }, [assistant.language_questions, language, assistant.quick_questions]);

  return (
    <Box
      sx={{
        height: height,
        width: "100%",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
        py: 4,
        px: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Box sx={{ mb: 3 }}>
          <img
            src="/images/Arch_Amazon-Bedrock_64.png"
            alt="Powered By AWS"
            style={{
              height: "auto",
              width: "256px",
              maxWidth: "100%",
            }}
          />
        </Box>

        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: 600,
            color: "text.primary",
          }}
          gutterBottom
        >
          Agents for Amazon Bedrock
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "1rem", sm: "1.1rem" },
            mb: 4
          }}
          gutterBottom
        >
          {assistant.welcome_message}
        </Typography>

        <Grid container spacing={2} sx={{ pb: 2 }} justifyContent="center">
          {getLanguageQuestions.map((question, index) => (
            <Grid item xs={12} md={6} key={`language-question-${index}`}>
              <Paper
                elevation={0}
                onClick={() => handleExample(question)}
                sx={{
                  px: 2,
                  py: 1,
                  height: "100%",
                  cursor: "pointer",
                  textAlign: "center",
                  border: "1px solid",
                  borderColor: "rgba(0, 0, 0, 0.05)",
                  borderRadius: 4,
                  backgroundColor: "rgba(255, 255, 255, 0.1)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                    borderColor: index % 2 === 0 ? "primary.light" : "secondary.light",
                    transform: "translateY(-4px)",
                  },
                }}
                data-amplify-analytics-on="click"
                data-amplify-analytics-name="click"
                data-amplify-analytics-attrs={`button:example-${index}`}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: "text.secondary"
                  }}
                >
                  {question}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default WelcomeView;